import React, { Component } from "react";
import axios from "axios";
import navbar from "../../helpers/navbar";

class WarrantBody extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: null,
      warrants: []
    };
    this.trackDownload = this.trackDownload.bind(this);
  }
  componentDidMount() {
    this.setDefaults();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.page !== this.props.page) {
      this.setDefaults();
    }
  }
  trackDownload(e) {
    axios.post("/postDownload", { eventName: e }).catch(e => console.error(e));
  }
  setDefaults() {
    let defaultAll = null;
    if (this.props.defaultAll) {
      document.querySelector(".allButton").classList.add("selected");
      defaultAll = "All";
    }
    let warrantObjectKeys = Object.keys(this.props.warrants);
    if (warrantObjectKeys.length > 0) {
      this.setState({
        warrants: this.props.warrants,
        active: defaultAll
      });
    }
  }
  render() {
    let categories = [];
    let files = [];
    let banner;
    for (let category in this.state.warrants) {
      if (category === "_root") {
        continue;
      }
      categories.push(
        <button
          type="button"
          className="selectCategory"
          key={category + "Button"}
          onClick={e => {
            navbar("selectCategory", e.currentTarget);
            this.setState({ active: category });
            location.href="#warrantsTop";
          }}
        >
          {category}
        </button>
      );
    }
    categories.sort((a, b) => (a.key > b.key) ? 1 : -1);
    let allButton = this.props.defaultAll ? (
      <button
        type="button"
        className="selectCategory selected allButton"
        key={"AllButton"}
        onClick={e => {
          navbar("selectCategory", e.target);
          this.setState({ active: "All" });
        }}
      >
        All
              </button>
    ) : "";
    if (this.state.active !== null) {
      let active = [];
      if (this.state.active === "All") {
        for (let warrant in this.state.warrants) {
          active.push(this.state.warrants[warrant]);
        }
        active = active.reduce((prev, curr) => prev.concat(curr));
      } else {
        active = this.state.warrants[this.state.active];
      }
      active.forEach((warrantFile, index) => {
        let desc;
        if (warrantFile.Description) {
          desc = <span>{warrantFile.Description}</span>;
        }
        files.push(
          <div
            className="warrantBody__file"
            key={warrantFile.Name + "File" + index}
            onClick={() => this.trackDownload(warrantFile.Name)}
          >
            <a
              href={
                "https://warrantporproductionstor.blob.core.windows.net/warrantportalblob/" +
                warrantFile.Subfolder + "/" +
                warrantFile.Name
              }
            >
              {warrantFile.Name}
            </a>
            {desc}
          </div>
        );
        files.sort((a, b) => (a.key > b.key) ? 1 : -1);
      });
    } else {
      files = (
        <div className="warrantBody__noFile">Select the appropriate topic from the left column to see available templates.</div>
      );
    }
    switch (this.props.banner) {
      case "info":
        banner = <div className="warrantBody__header">Nothing</div>;
        break;
      case "icac":
        banner = 
        <div className="warrantBody__header">
          <p>We strongly encourage law enforcement to start each search warrant from a new template obtained from this site. These templates are maintained by the ICAC DPA.</p>
          <p>For King County cases, we also encourage law enforcement to seek prosecutorial review of every warrant that is beyond the most basic or any warrant for which you are unfamiliar or have questions or concerns. The ICAC Deputy, Laura Harmon, can be reached at (206) <span>491-</span>8295 or <a href="mailto:lharmon@kingcounty.gov">lharmon@kingcounty.gov</a>. </p>
          <p>Each category contains macros and non-macros versions of the warrant.  Macros version means the document will prompt you to input details regarding your case and then populate that data into the document for you.  Non-macros warrants are traditional document templates.  If you are having any issues with the warrants, you can call DPA Laura Harmon at the contact information above.</p>
        </div>;
        break;
      case "traffic":
        banner = 
          <div className="warrantBody__header">
            <p>We strongly encourage law enforcement to start each search warrant from a new template obtained from this site. These templates are maintained by the felony traffic DPA.</p>
            <p>For King County cases, we also encourage law enforcement to seek prosecutorial review of every warrant that is beyond the most basic or any warrant for which you are unfamiliar or have questions or concerns. The felony traffic deputy, Amy Freedheim, can be reached at Desk:  (206) <span>477</span>-1921; Cell phone:  (206) <span>402-</span>7603; or <a href="mailto:amy.freedheim@kingcounty.gov">amy.freedheim@kingcounty.gov</a>. </p>
          </div>;
        break;
      case "consent":
        banner = <div className="warrantBody__header">Nothing</div>;
        break;
        case "firearm":
        banner = <div className="warrantBody__header"><p>Test Fire Banner</p></div>;
        break;
      case "electric":
        banner = 
          <div className="warrantBody__header">
            <p>We strongly encourage law enforcement to start each electronic surveillance order from a new template obtained from this site, because these templates are routinely updated by the Special Operations Unit.</p>
            <p>For King County electronic surveillance matters, law enforcement should engage Gary Ernsdorff, Kathy Ungerman, and/or Stephen Anderson.  The KCPAO Special Operations deputies can be reached at (206) 4 SPEC OPs (206-<span>477</span>-3267) or via email at <a href="mailto:PAOSpecOps@kingcounty.gov">PAOSpecOps@kingcounty.gov</a>.</p>
          </div>;
        break;
      case "warrant":
        banner = 
          <div className="warrantBody__header">
            <p>We strongly encourage law enforcement to start each search warrant from a new template obtained from this site, because these templates are routinely updated by the Special Operations Unit. For all law enforcement within King County, DO NOT change the footers on the templates. If you are from an agency outside of King County, please update the footer to accurately reflect your county’s contact information.</p>
            <p>
            For King County cases, we also encourage law enforcement to seek prosecutorial review of every warrant that is beyond the most basic or any warrant for which you are unfamiliar or have questions or concerns. A contact list of available prosecutors can be found in the Contact Information and Resources tab in the upper right hand corner of this page.
            </p>
          </div>;
        break;
      case -1:
      default:
        banner = <div></div>
        break;
    }
    return (
      <div id="warrantsTop" className="warrantBody__container">
        {banner}
        <div className="warrantBody__body">
          <div className="warrantBody__categories">
            <div className="warrantBody__categoriesHeader">Categories</div>
            <div className="warrantBody__categoriesBody">
              {allButton}
              {categories}
            </div>
            <br />
            <br />
            <br />
          </div>
          <div className="warrantBody__list">
            <div className="warrantBody__files">{files}</div>
            <br />
            <br />
            <br />
          </div>
        </div>
      </div>
    );
  }
}

export default WarrantBody;
